import { menuItemSX } from "../components/Builder/BuilderConst";

export const commonInputStyles = {
  "& .MuiInputBase-root": {
    height: 35,
    fontSize: 14,
    borderRadius: "var(--form-border-input-radius)",
    backgroundColor: "#ffffff",
    overflow: "hidden",
    "& fieldset": {
      borderColor: "#d8d8d8",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#d8d8d8",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#d8d8d8",
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: 14,
    top: "-5px",
  },
};

export const commonBlueInputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "var(--form-border-input-radius)",
    backgroundColor: "#ffffff",
    "& fieldset": {
      borderRadius: "var(--form-border-input-radius)",
      borderColor: "#d8d8d8",
    },
    "&:hover fieldset": {
      borderColor: "#1976d2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& .MuiInputBase-input": {
    padding: "8px 14px",
    fontSize: 14,
    fontFamily: "var(--font-family-manrope, 'Manrope')",
    color: "#000000de",
  },
  "& .MuiInputAdornment-root": {
    marginLeft: "2px",
    marginRight: "4px",
  },
  "& .MuiInputAdornment-root + .MuiInputBase-input": {
    paddingLeft: "0px !important",
  },
};

export const commonSelectStyles = {
  borderRadius: "var(--form-border-input-radius)",
  border: "1px solid #d8d8d8",
  height: 35,
  width: "fit-content",
  minWidth: "fit-content",
  backgroundColor: "#ffffff",
  transition: "all 0.2s ease",
  fontSize: "14px",
  fontFamily: "var(--font-family-manrope)",

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiSelect-select": {
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "14px",
    fontFamily: "var(--font-family-manrope)",
  },

  "&:hover": {
    borderColor: "#1976d2",
    boxShadow: "0 0 0 1px rgba(25, 118, 210, 0.2)",
  },

  // ✅ Add focus effect
  "&.Mui-focused": {
    borderColor: "#1976d2",
    boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
  },
};

export const commonMenuProps = {
  PaperProps: {
    sx: {
      mt: 1,
      borderRadius: "var(--medium-border-radius)",
      boxShadow: "none",
      border: "1px solid #d8d8d8",
      minWidth: 240,
      maxHeight: 280,
      p: 0.5,
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
        width: 0,
        height: 0,
      },
      "& .MuiList-root, & .MuiAutocomplete-listbox": {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
          width: 0,
          height: 0,
        },
      },
    },
  },
  anchorOrigin: { vertical: "bottom", horizontal: "right" } as const,
  transformOrigin: { vertical: "top", horizontal: "right" } as const,
};

export const commonTooltipProps = {
  tooltip: {
    sx: {
      backgroundColor: "#ffffff",
      color: "#5e5d5dff",
      border: "1px solid #d8d8d8",
      fontSize: "12px",
      borderRadius: "var(--small-border-radius)",
      fontWeight: 500,
      p: 1,
      fontFamily: "var(--font-family-manrope), sans-serif",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    },
  },
  arrow: {
    sx: {
      color: "#d8d8d8",
    },
  },
};

export const commonSwitchStyles = {
  width: 42,
  height: 24,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: "2px",
    margin: 0,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#ffffff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          "var(--action-button-background-color, #2563eb) !important",
        opacity: "1 !important",
        border: 0,
      },
    },
    "&.Mui-disabled": {
      color: "#ffffff",
      cursor: "not-allowed",
      "& + .MuiSwitch-track": {
        opacity: "0.45 !important",
        cursor: "not-allowed",
      },
    },
    "&.Mui-checked.Mui-disabled": {
      color: "#ffffff",
      opacity: 0.9,
      "& + .MuiSwitch-track": {
        backgroundColor:
          "var(--action-button-background-color, #2563eb) !important",
        opacity: "0.45 !important",
        cursor: "not-allowed",
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 20,
      height: 20,
      backgroundColor: "#ffffff",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 12,
    backgroundColor: "#cbd5e1 !important",
    opacity: "1 !important",
    transition: "background-color 300ms",
  },
  "&.Mui-disabled": {
    cursor: "not-allowed",
  },
};

export const commonSliderStyles = {
  height: 6,
  padding: "10px 0",
  width: "calc(100% - 21px)",
  ml: "14px",
  mr: "7px",
  boxSizing: "border-box",
  "& .MuiSlider-rail": {
    backgroundColor: "#f1f5f9",
    border: "1px solid #d0d5dd",
    opacity: "1 !important",
    height: 6,
    borderRadius: "9999px",
    boxSizing: "border-box",
  },
  "& .MuiSlider-track": {
    backgroundColor:
      "var(--action-button-background-color, #2563eb) !important",
    border: "none",
    height: 6,
    borderRadius: "9999px",
  },
  "& .MuiSlider-thumb": {
    width: 14,
    height: 14,
    backgroundColor:
      "var(--action-button-background-color, #2563eb) !important",
    border: "none",
    boxShadow: "none",
    "&:hover, &.Mui-focusVisible": {
      boxShadow: "0 0 0 6px rgba(37, 99, 235, 0.16)",
    },
    "&.Mui-active": {
      boxShadow: "0 0 0 8px rgba(37, 99, 235, 0.2)",
    },
  },
};
export const multiSelectMenuItemSX = {
  /* ---------- Size & Spacing (Exact match to menuItemSX) ---------- */
  py: "6px !important",
  px: "12px !important",
  mx: "4px !important",
  my: "2px !important",
  borderRadius: "var(--small-border-radius) !important",

  fontWeight: "400 !important",
  fontSize: "14px !important",
  fontFamily: "var(--font-family-manrope)",
  color: "#000000de !important",
  backgroundColor: "transparent !important",
  display: "flex !important",
  justifyContent: "space-between !important",
  alignItems: "center !important",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
    width: 0,
    height: 0,
  },

  "&:hover": {
    backgroundColor: "#f5f5f5 !important",
    boxShadow: "none !important",
    color: "#000000de !important",
  },

  "&.Mui-selected": {
    backgroundColor: "transparent !important",
    color: "#000000de !important",
    fontWeight: "400 !important",
    boxShadow: "none !important",
  },

  "&.Mui-selected:hover": {
    backgroundColor: "#f5f5f5 !important",
    color: "#000000de !important",
    boxShadow: "none !important",
  },

  "&.Mui-focusVisible": {
    backgroundColor: "#f5f5f5 !important",
  },

  /* ---------- Edge Items ---------- */
  "&:first-of-type": { mt: "3px !important" },
  "&:last-of-type": { mb: "3px !important" },
};

export const multiSelectStyle = multiSelectMenuItemSX;
